import { render, staticRenderFns } from "./RfidAbnormal.vue?vue&type=template&id=086c6872&scoped=true&"
import script from "./RfidAbnormal.vue?vue&type=script&lang=js&"
export * from "./RfidAbnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c6872",
  null
  
)

export default component.exports